import React from 'react';

/** Emphasize an authored action lead without shortening or replacing its instructions. */
export default function InstructionText({ text }: { text: string }) {
  const action = text.match(/^([^:\n]{2,48}:)\s+([\s\S]+)$/);
  return action ? <><strong>{action[1]}</strong>{' '}{action[2]}</> : <>{text}</>;
}
